import "../../../css/Pagination/Pagination.css";

/** Build the page range with optional ellipses */
function getRange(start, end) {
  const len = end - start + 1;
  return Array.from({ length: len }, (_, i) => i + start);
}

function usePagination({ currentPage, totalPages, boundaryCount = 1 }) {
  if (totalPages <= 3) {
    return getRange(1, totalPages);
  }

  const pages = [];

  // Always show first page
  pages.push(1);

  // Determine middle window (2 items only)
  let middleStart = Math.max(currentPage - 1, 2);
  let middleEnd = middleStart + 1;

  // Clamp near end
  if (middleEnd >= totalPages) {
    middleEnd = totalPages - 1;
    middleStart = middleEnd - 1;
  }

  // Left dots
  if (middleStart > 2) {
    pages.push("…");
  }

  // Middle pages (ONLY TWO)
  pages.push(...getRange(middleStart, middleEnd));

  // Right dots
  if (middleEnd < totalPages - 1) {
    pages.push("…");
  }

  // Always show last page
  pages.push(totalPages);

  return pages;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  siblingCount = 1,
  boundaryCount = 1,
  className = "",
}) {
  const range = usePagination({
    currentPage,
    totalPages,
    siblingCount,
    boundaryCount,
  });

  const go = (p) => {
    if (p < 1 || p > totalPages || p === currentPage) return;
    onPageChange?.(p);
  };

  const disabledPrev = currentPage <= 1;
  const disabledNext = currentPage >= totalPages;

  return (
    <nav
      className={`aml-pagination ${className}`}
      aria-label="Pagination Navigation"
    >
      <button
        className="pg-link pg-prev AML-Text-Body"
        onClick={() => go(currentPage - 1)}
        disabled={disabledPrev}
        aria-label="Previous page"
      >
        Prev
      </button>

      <div className="pg-list">
        {range.map((item, idx) =>
          item === "…" ? (
            <div key={`dots-${idx}`} className="pg-dots" aria-hidden="true">
              ..
            </div>
          ) : (
            <div key={item}>
              <button
                className={`pg-link pg-number ${
                  item === currentPage ? "is-active" : ""
                }`}
                onClick={() => go(item)}
                aria-current={item === currentPage ? "page" : undefined}
              >
                {item}
              </button>
            </div>
          )
        )}
      </div>

      <button
        className="pg-link pg-next AML-Text-Body"
        onClick={() => go(currentPage + 1)}
        disabled={disabledNext}
        aria-label="Next page"
      >
        Next
      </button>
    </nav>
  );
}
